import {createSelector} from 'reselect';
import {fromJS, List as ImmutableList, Map} from 'immutable';
import * as K from "../constants/constants";

const getLatestSearchQuery = store => store.globalSearchResults.getIn([ (store.globalSearchResults.size - 1)], "id");
const getAllSearches = store => store.globalSearchResults;
const getSearchQuery = store => store.viewstate.get("globalSearchQuery");
const getSearchFilters = store => store.searchFilters;
const getGlobalSearchFilter = store => store.viewstate.get("globalSearchFilter");
const getFilterType = store => store.searchFilters.getIn([getGlobalSearchFilter(store), "label"]);
const getAllParam = store => store.searchFilters.keySeq().first();
const getPageNum = store => store.viewstate.get("currentPage");
const getMaxResults = () => K.MAX_SEARCH_RESULTS;

// Search the store if there is a cached search object with matches the current query
export const getResultsByQuery = createSelector(
	[getSearchQuery, getAllSearches],
	(query, searches) => {

		if ( !query || searches.size < 1) {
			return ImmutableList();
		}
		let now = Date.now();
		// TODO: Consider what happens if the user is in offline mode
		let isOffline = false;
		const isActiveEntry = entry => isOffline ? true : ( entry.get("expires") < now )

		return searches.filter( (entry)=>{
			return entry.get("id") === query && isActiveEntry(entry);
		}).getIn([0,"results"]);
	}
);

export const getFilteredResults = createSelector(
	[getGlobalSearchFilter, getFilterType, getResultsByQuery, getAllParam],
	(filtr, type, allResults, allParam) => {

		if( !allResults || allResults.size < 1 ) {
			return ImmutableList();
		}
		if (filtr === allParam) {
			return allResults;
		}
		// filtr is the global search variable in english
		// type is the variable set in the results which is in swedish
		return allResults.filter( result => result.get("type") === type )
	}
)

export const getPaginatedResults = createSelector(
	[getFilteredResults, getPageNum, getMaxResults],
	(results, page) => {

	}
)

// Build up an object for the search tabs
// TODO: check if this should actually be located in the selectors folder
export const getSearchTabs = createSelector(
	[getSearchFilters, getGlobalSearchFilter],
	(filters, filtr) => {

		let list = [];

		if (!filters) {
			return ImmutableList();
		}

		filters.forEach( (item, key, i) => {
			list.push( {
				value: key,
				path: item.get("path"),
				label: item.get("label"),
				checked: (filtr === key)
			})
		} );

		return fromJS(list);
	}
)



// WEBPACK FOOTER //
// ./src/js/selectors/globalSearch.js